require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.set');
module.exports = require('../modules/_core').Set;



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/es6/set.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/es6/set.js
// module chunks = 168707334958949